<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav class="pull-left">
        <ul>
          <li>
            <a href="http://www.ciip.ch/">
              Conférence intercantonale de l'instruction publique
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright pull-right">
        <span
          >Développé avec <i class="fa fa-heart heart" /> à l'<a
            href="http://www.iict.ch"
            target="_blank"
            rel="noopener"
            >IICT</a
          ></span
        >
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>
